// ** Reducers Imports
import layout from "./layout"
import navbar from "./navbar"
import authReducer from "./auth/reducers"
import commonreducerSlice from "../views/redux/store"
const rootReducer = { navbar, layout, authReducer, commonreducerSlice }

export default rootReducer
